import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "./Sidebar.module.css";

const SidebarBrand = ({ isCollapsed, onToggleCollapse }) => {
  return (
    <div className={styles.brandWrapper}>
      <Link to="/dashboard" className={styles.brandLink}>
        <img
          src="/splash_logo.png"
          alt="AsmitA Logo"
          className={styles.brandLogo}
        />
        {!isCollapsed && (
          <div className={styles.brandInfo}>
            <div className={styles.brandTitle}>
              my<span>AsmitA</span>
            </div>
            <div className={styles.brandSubtitle}>Operations Hub</div>
          </div>
        )}
      </Link>

      <button
        type="button"
        onClick={onToggleCollapse}
        className={styles.collapseBtn}
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {isCollapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
      </button>
    </div>
  );
};

export default SidebarBrand;
